import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { keycloak } from './app/auth/keycloak';

async function initKeycloak() {
  await keycloak.init({
    onLoad: 'login-required',
    pkceMethod: 'S256',
    checkLoginIframe: false,
  });
}

initKeycloak()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error('Keycloak init failed', err));
